<template>
    <section class="main">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i> 实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>ProjectData</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="plugins-tips">

                <el-input v-model="query.name" placeholder="Filter" @keyup.enter.native="handleSearch" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <span style='margin-left: 20px; color: #67C23A; font-size: 15px'>查询条件："name"</span>
                <el-button type="primary" icon="el-icon-upload2" @click="showInsertDialog()" style="float: right; margin-right: 20px">新增</el-button>

            </div>
            
            <el-table
                :data="table.tableData"
                v-loading="table.loading"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{textAlign: 'center'}"
                @selection-change="handleSelectionChange"
                :default-sort = "{prop: 'createTime', order: 'descending'}"
                >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column label="ID" prop="objectId" width="183px"></el-table-column>
                <el-table-column label="name" prop='name'/>
                <el-table-column label="cnName" prop='cnName'/>
                <el-table-column label="biz_id" prop="bizId"  width="87px"></el-table-column>
                <el-table-column label="app_id" prop="appId" width="219px"></el-table-column>
                <el-table-column label="secret_key" prop="secretKey" width="228px"></el-table-column>
                <el-table-column label="code" prop="code" width="90px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.code == '0'" type="success">本地默认</el-tag>
                        <el-tag v-if="scope.row.code == '-1'">国家正式</el-tag>
                        <el-tag v-if="scope.row.code == '-2'" type="info">国家测试</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="holiday" prop="holiday" width="90px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.holiday == '0'" type="warning">非节假日</el-tag>
                        <el-tag v-if="scope.row.holiday == '1'">节假日</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="createTime" prop="createTime" :formatter="dateFormat" width="132px" sortable></el-table-column>
                <el-table-column label="updateTime" prop="updateTime" :formatter="dateFormat" width="132px" sortable></el-table-column>
                <el-table-column label="operation" prop="code" width="100px">
                    <template slot-scope="scope">
                        <!-- 修改按钮 -->
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.objectId)"></el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页导航 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :current-page="table.pageIndex"
                    :page-size="table.pageSize"
                    :total="table.pageTotal"
                    :page-sizes='[15, 30, 45, 60]'
                    @size-change='handleSizeChange'
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!------------------------------------------------- 新增用户的对话框 -->
        <el-dialog
          title="新增数据"
          :visible.sync="insertDialogVisible"
          width="50%"
          :close-on-click-modal="false"
          @close="insertDialogClosed">
          <el-form :model="insertForm" ref="insertFormRef" :rules="insertRole" label-width="80px">
            <el-form-item label="项目" prop="projectAppId">
              <el-select v-model='insertForm.projectAppId' filterable size='mini' placeholder='请选择项目'>
                  <el-option v-for='(item, index) in projectInfoList' :key='item.id' :label='item.cnName' :value='item.appId'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="biz_id" prop="bizId">
              <el-input v-model="insertForm.bizId"></el-input>
            </el-form-item>
            <el-form-item label="app_id" prop="appId">
              <el-input v-model="insertForm.appId"></el-input>
            </el-form-item>
            <el-form-item label="secret_key" prop="secretKey">
              <el-input v-model="insertForm.secretKey"></el-input>
            </el-form-item>
            <!-- code 0: 本地测试    -1: 国家正式API   -2: 国家测试API -->
            <el-form-item label="code">
                <el-select v-model="insertForm.code" placeholder="请选择" :key="insertForm.code">
                    <el-option label="本地默认" :value="0"></el-option>
                    <el-option label="国家正式" :value="-1"></el-option>
                    <el-option label="国家测试" :value="-2"></el-option>
                </el-select>
            </el-form-item>
            <!-- 0：非节假日   1：节假日 -->
            <el-form-item label="holiday" prop="holiday">
                <el-select v-model="insertForm.holiday" placeholder="请选择" :key="insertForm.holiday">
                    <el-option label="非节假日" :value="0"></el-option>
                    <el-option label="节假日" :value="1"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="insertDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="insertAntiProjectData" :loading="this.postLoading">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 修改用户的对话框 -->
        <el-dialog
          title="修改信息"
          :visible.sync="editDialogVisible"
          width="50%"
          :close-on-click-modal="false"
          @close="editDialogClosed">
          <el-form :model="editForm" ref="editFormRef" :rules="editRole" label-width="80px">
            
            <el-form-item label="ID" prop="objectId">
              <el-input v-model="editForm.objectId" disabled></el-input>
            </el-form-item>
              <el-form-item label="项目" prop="projectAppId">
                  <el-select v-model='editForm.projectAppId' filterable size='mini' placeholder='请选择项目'>
                      <el-option v-for='(item, index) in projectInfoList' :key='item.id' :label='item.cnName' :value='item.appId'></el-option>
                  </el-select>
              </el-form-item>
            <el-form-item label="biz_id" prop="bizId">
              <el-input v-model="editForm.bizId"></el-input>
            </el-form-item>
            <el-form-item label="app_id" prop="appId">
              <el-input v-model="editForm.appId"></el-input>
            </el-form-item>
            <el-form-item label="secret_key" prop="secretKey">
              <el-input v-model="editForm.secretKey"></el-input>
            </el-form-item>
            <!-- code 0: 本地测试    -1: 国家正式API   -2: 国家测试API -->
            <el-form-item label="code">
                <el-select v-model="editForm.code" placeholder="请选择" :key="editForm.code">
                    <el-option label="本地默认" :value="0"></el-option>
                    <el-option label="国家正式" :value="-1"></el-option>
                    <el-option label="国家测试" :value="-2"></el-option>
                </el-select>
            </el-form-item>
            <!-- 0：非节假日   1：节假日 -->
            <el-form-item label="holiday" prop="holiday">
                <el-select v-model="editForm.holiday" placeholder="请选择" :key="editForm.holiday">
                    <el-option label="非节假日" :value="0"></el-option>
                    <el-option label="节假日" :value="1"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editAntiProjectData">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="批量修改信息"
          :visible.sync="editMultipleDialogVisible"
          width="50%"
          :close-on-click-modal="false"
          @close="editMultipleDialogClosed">
          <el-form :model="editMultipleForm" ref="editMultipleFormRef" label-width="80px">
            <h4 style="margin-bottom: 20px; text-align: center">已选中 {{this.multipleSelection.length}} 条数据</h4>
            <el-form-item label="secretKey" prop="secretKey">
              <el-input v-model="editMultipleForm.secretKey" placeholder="update key"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editMultipleDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editMultipleAntiProjectData">确 定</el-button>
          </span>

        </el-dialog>
    </section>
</template>

<script>
import moment from 'moment';
import {
    getAntiProjectDataPage,
    getProjectDataByObjectId,
    postAntiProjectData,
    updateAntiProjectData,
    updateMultipleAntiProjectData
} from '../../api/antiaddiction.js';
import { queryProjectInfoList } from '../../api/ProjectInfo';

export default {
    name: 'AntiProjectData',
    data() {
        return {
            // 控制新增用户对话框的显示与隐藏，默认为隐藏
            insertDialogVisible: false,
            // 新增数据 对话框
            insertForm: {
                projectAppId: '',
                bizId: '',
                appId: '',
                secretKey: '',
                code: '',
                holiday: ''
            },
            // 新增数据按钮 等待响应动画
            postLoading: false,
            insertRole: {
                projectAppId: [{ required: true, message: '请选择项目', trigger: 'blur'}]
            },

            // 控制修改用户对话框的显示与隐藏，默认为隐藏
            editDialogVisible: false,
            // 修改数据 对话框
            editForm: {
                projectAppId: '',
                bizId: '',
                appId: '',
                secretKey: '',
                code: '',
                holiday: ''
            },
            editRole:{
                projectAppId: [{ required: true, message: '请选择项目', trigger: 'blur'}]
            },

            // 控制批量操作用户对话框的显示与隐藏，默认为隐藏
            editMultipleDialogVisible: false,
            // 批量操作集合
            multipleSelection: [],
            //批量操作 对话框
            editMultipleForm: {
                secretKey: ''
            },

            // 查询条件
            query: {
                addProjectName: '', //新增项目名
                name: '',           //搜索框
            },
            // 表单数据
            table: {
                tableData: [],
                pageIndex: 1,   // 页码
                pageTotal: 0,   // 总数据量
                pageSize: 15,    // 单页数据量
                loading: false  // 加载动画
            },
            projectInfoList: [],
            projectInfoListMap: new Map,
        }
    },
    created() {
        this.getAntiProjectData()
    },
    computed: {
        computeProjectName() {
            return (projectAppId) => {
                if (this.projectInfoListMap.get(projectAppId)) {
                    return this.projectInfoListMap.get(projectAppId).name
                }
                return ''
            }
        },
        computeProjectCnName() {
            return (projectAppId) => {
                if (this.projectInfoListMap.get(projectAppId)) {
                    return this.projectInfoListMap.get(projectAppId).cnName
                }
                return ''
            }
        }
    },
    activated() {
        this.getAntiProjectData()
    },
    methods: {
        // 项目名称信息
        getAntiProjectData() {
            
            this.table.loading = true
            let name = this.query.name
            // 发送请求
            let params = {'pageNum' : this.table.pageIndex, 'name' : name, 'pageSize': this.table.pageSize }
            getAntiProjectDataPage(params).then(res => {
                if (res.data.code == 200) {
                    this.table.tableData = res.data.data.records
                    this.table.pageTotal = res.data.data.total
                    this.table.pageSize = res.data.data.size
                    
                    this.table.loading = true
                } else {
                    this.$message.error(res.data.message)
                }
                this.table.loading = false
                
            }).catch(err =>{
                this.$message.error('获取项目名称失败')
                this.table.loading = false
            })
            
            // 查询项目数据
            this.projectInfoList = []
            this.projectInfoListMap = new Map
            queryProjectInfoList({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result
                    result.data.result.forEach(projectInfo => {
                        this.projectInfoListMap.set(projectInfo.appId, projectInfo)
                    })
                }
            })
        },

        // 触发搜索按钮
        handleSearch() {
            this.table.pageIndex = 1
            this.getAntiProjectData();
        },

        // 展示新增AntiProjectData对话框
        showInsertDialog() {
            this.insertDialogVisible = true;
        },

        // 新增form表单
        insertAntiProjectData() {
            this.$refs.insertFormRef.validate(valid => {
                if (valid) {
                    this.postLoading = true
                    let params = JSON.stringify(this.insertForm)
                    postAntiProjectData(params).then(res => {
                        if (res.data.code === 200) {
                            // 新增成功, 更新页面
                            this.getAntiProjectData()
                            this.$message.success ('新增成功')
                            this.insertDialogVisible = false
                        } else {
                            this.$message.error ('新增失败')
                        }
                    })
                }
            })
            this.postLoading = false
        },

        // 监听新增AntiProjectData对话框的关闭
        insertDialogClosed() {
            this.$refs.insertFormRef.resetFields()
        },

        // 展示编辑用户的对话框
        showEditDialog(id) {
            // false 为单个操作, true 为多选操作
            let flag = false;
            // 循环多选操作数据集合, 长度大于1 并点击修改已选中为多选操作
            this.multipleSelection.forEach((item, idnex) => {
                if (id == item.objectId && this.multipleSelection.length > 1) {
                    flag = true
                    return
                }
            })

            // 单选 与 多选, 操作栏展示
            if (flag == true) {
                this.editMultipleDialogVisible = true
            } else {
                let params = {'objectId': id}
                getProjectDataByObjectId(params).then(res => {
                    let result = res.data;
                    if (result.code === 200) {
                        this.editForm = result.data
                        console.log(this.editForm);
                        this.editDialogVisible = true
                    } else {
                        this.$message.error(result.message)
                    }
                })
            }
        },

        // 修改表单提交
        editAntiProjectData() {
            this.$refs.editFormRef.validate(valid => {
                if (valid) {
                    let params = JSON.stringify(this.editForm)
                    updateAntiProjectData(params).then(res => {
                        let result = res.data;

                        if (result.code === 200) {
                            // 修改成功, 更新表格
                            this.getAntiProjectData()

                            this.$message.success ('修改成功')
                            this.editDialogVisible = false
                        } else {
                            this.$message.error ('修改失败')
                        }
                    })
                }
            })
        },

        // 批量修改表单提交
        editMultipleAntiProjectData () {
            this.$refs.editMultipleFormRef.validate(valid => {
                // 替换集合中的 secretKey
                this.multipleSelection.forEach((item, index) => {
                    item.secretKey = this.editMultipleForm.secretKey
                })

                let params = JSON.stringify(this.multipleSelection)
                updateMultipleAntiProjectData(params).then(res => {
                    // let result = JSON.parse(res.data)
                    let result = res.data
                    if (typeof res.data === 'string') {
                        result = JSON.parse(res.data)
                    }
                    if (result.code === 200) {
                        // 修改成功, 更新页面
                        this.getAntiProjectData()

                        this.$message({
                            showClose: true,
                            message: '共' + this.multipleSelection.length + '条数据, 成功' + result.data + '条',
                            type: 'success'
                        })
                        this.editMultipleDialogVisible = false
                    } else {
                        this.$message.error ('修改失败')
                    }
                })
            })
        },

        // 分页导航
        handlePageChange(val) {
            this.table.pageIndex = val
            this.getAntiProjectData()
        },
        handleSizeChange(size) {
            this.table.pageSize = size
            this.getAntiProjectData()
        },

        // 监听编辑用户对话框的关闭
        editDialogClosed() {
            this.$refs.editFormRef.resetFields()
        },

        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val
        },

        // 监听修改多选用户对话框关闭
        editMultipleDialogClosed() {
            this.$refs.editMultipleFormRef.resetFields()
        },

        //el-Tbale 显示时间格式
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        }
    }
}
</script>

<style scoped lang="scss">
.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
